import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import { router } from './router'
import Vuelidate from 'vuelidate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import { HToast } from 'vue-haichi'
require('vue-haichi/dist/haichi.umd.js')
import VueI18n from 'vue-i18n'
import('../src/css/main.css')
Vue.use(VueI18n)
Vue.config.productionTip = false
//Vue.use(VueHaichi)
Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(HToast)
Vue.use(VueMeta, {
  keyName: 'head',
})

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: require('./locales/en.json'),
  },
})

new Vue({
  i18n: i18n,
  router,
  //VueHaichi,
  render: (h) => h(App),
}).$mount('#app')
